module.exports = __webpack_public_path__ + "static/img/loading-16-9.bb1cfe9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/loading/loading-16-9.jpg
// module id = tDbr
// module chunks = 20